import Vue from 'vue';
import { MutationTree } from 'vuex';

// Store types
import { RootState, FooterFloatingAction, FooterNext, FooterMutation, FooterInfo } from '@/store/store.types';

// Step types
import { StepConfig } from '@/steps/types';

/**
 *  Holding all the mutations of the footer.
 */
export const Mutations: MutationTree<RootState> = {

    /**
     *
     *  Used to update the state of the footer's floating action
     *
     *  @param action The action to show on smaller screens or null to remove it
     *
     */
    [FooterMutation.FLOATING_ACTION](state: RootState, action: FooterFloatingAction | null): void {

        state.footer.floatingAction = action;

    },

    /**
     *
     *  Used to update the state of the footer's info.
     *
     *  (i) Supports HTML
     *
     *  @param info The info to show or null to remove it
     *
     */
    [FooterMutation.INFO](state: RootState, info: FooterInfo | null): void {

        state.footer.info = info;

    },

    /**
     *
     *  Used to update the state of the footer's next button.
     *
     *  @param settings The (updated) settings of the footer's
     *  next button or null to remove it
     *
     */
    [FooterMutation.NEXT](state: RootState, settings: FooterNext | null): void {

        if (!settings) {

            state.footer.next = null;

            return;

        }

        state.footer.next = {
            ...state.footer.next,
            ...settings,
        };

        /**
         *  Because the `title` and `content` are used by default
         *  in the footer, we need to update the step and `title`
         *  and `content` correctly to let it work as expected.
         */
        if (!settings.step) {

            return;

        }

        Vue.set<StepConfig | null>(state.footer.next, 'step', settings.step);

        delete state.footer.next.title;
        delete state.footer.next.content;

    },

};
